var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){_vm.visible = true;
        _vm.fetch();}}},[_vm._t("default"),_c('el-dialog',{staticClass:"center",attrs:{"visible":_vm.visible,"title":"用户白名单","width":"535px","append-to-body":true},on:{"close":function($event){_vm.visible = false}},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('conf-table',{ref:"tableRef",attrs:{"api":_vm.api,"columns":_vm.columns,"pagination":{
                pageSize: 8,
                layout: 'total, prev, pager, next',
            }}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }